define.alias("shared/modifiers/scroll-to-top", "preview-grid/modifiers/scroll-to-top");